import { useState } from "react";
import { useT } from "@/i18n";
import { PageHeader, useApi } from "@/components/common";
import AuditTable from "@/components/AuditTable";

export default function PlatformAuditView() { const { t } = useT();
  const [filters, setFilters] = useState({ q: "", severity: "", page: 1 });
  const qs = new URLSearchParams({ page: filters.page, limit: 25, ...(filters.q && { q: filters.q }), ...(filters.severity && { severity: filters.severity }) }).toString();
  const audit = useApi(`/platform/audit?${qs}`);
  return (
    <div>
      <PageHeader eyebrow={t("lbl.platform")} title={t("lbl.global_audit_log")} subtitle="Every tenant, every platform action, every impersonation — with actor, IP, before/after." testId="platform-audit" />
      <AuditTable data={audit.data} loading={audit.loading} filters={filters} setFilters={setFilters} showTenant />
    </div>
  );
}
